import { useDataProvider } from 'context/DataProviderContext';
import { useState, useEffect } from 'react';
import { totalCountEvent } from 'services/generalServices';
import { listLeadStages } from 'services/Settings';

export default function useLeadStages() {
  const { leadStages, setLeadStages } = useDataProvider();
  const [isLoading, setIsLoading] = useState(false);

  const loadLeadStages = () => {
    setIsLoading(true);
    totalCountEvent('lead-stage')
      .then((response) => {
        listLeadStages(response.data, '', '', 'ACTIVE')
          .then((res) => setLeadStages(res.data?.lead_stage || []))
          .catch((error) => console.error(error))
          .finally(() => setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    leadStages?.length === 0 && loadLeadStages();
  }, []);

  return { leadStages, isLeadStageLoading: isLoading, loadLeadStages };
}
